import Checkbox from '@anm/components/form/Checkbox';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

import { DeleteRecordingInfo, FolderRow } from './Wrapper';
import { DeleteFolderRowProps } from './types';

const DeleteFolderRow: FC<DeleteFolderRowProps> = ({ isDisabled, isChecked, onChange }) => (
  <FolderRow {...{ isDisabled }}>
    <Checkbox checked={isChecked} onChange={isDisabled ? noop : onChange} />
    <DeleteRecordingInfo>
      <span>Delete the recording file</span>
    </DeleteRecordingInfo>
  </FolderRow>
);

export default DeleteFolderRow;
